<template>
  <div class="home-content">
    <swiper class="home_swiper" :options="swiperOptions" ref="mySwiper">
      <swiper-slide class="swiper_slide one">
        <div class="theme_title one">
          <h3 class="web">来布科技，专注于下一代底层数据技术研究<br/>数据确权和流通管控专家</h3>
          <h3 class="phone">来布科技，专注于下一代底层数据技术研究数据确权和流通管控专家</h3>
          <p>
            筚路蓝缕，开启人类有机新时代！<br/>
            百年长征，发展自主信息高科技！
          </p>
        </div>
        <img class="swiper_img" src="../assets/img/home1.png" alt="" />
      </swiper-slide>
      <!-- <swiper-slide class="swiper_slide two">
        <div class="theme_title two">
          <h3>数保保</h3>
          <p>
            "数保保"是来布科技基于数据2.0技术研发的一款用于政府、企业、个人重要敏感文件的数据确权，他人使用的管控软件。<br/>通过"数保保"安全分享给他人的重要敏感文件，让对方"可见不可得"，让我们在信任对方的同时，仍然有自我保护的能力，不再担心发出的文件会被泄漏。
          </p>
          <div class="to-details">
            <el-button type="primary" @click="toDetails">查看详情<i class="el-icon-right"></i></el-button>
            <p>支持Windows、Linux、Android、iOS移动设备</p>
          </div>
        </div>
        <img class="swiper_img" src="../assets/img/home2.png" alt="" />
      </swiper-slide> -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!-- 来布数据2.0技术介绍 -->
    <div class="home_02">
      <div class="title">来布数据2.0技术介绍</div>
      <p>数据2.0技术是由来布科技自主专利，独立研发新一代数据底层技术。基于数据2.0技术，可实现数据的确权分权，为我国数字经济的蓬勃发展提供有力支撑。</p>
      <div class="content">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <div class="content-item">
              <img class="content-item-left" src="../assets/img/tab1.png" alt="" />
              <div class="content-item-right">
                <div class="item-right-title">数据确权</div>
                <div class="item-right-content">可实现数据的三权分置(所有权、管理权、使用权)，支持独有共有多种产权模式</div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="content-item">
              <img class="content-item-left" src="../assets/img/tab5.png" alt="" />
              <div class="content-item-right">
                <div class="item-right-title">精准管控</div>
                <div class="item-right-content">数据授权可精细为查看人员、次数、有效期等限制条件</div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="content-item">
              <img class="content-item-left" src="../assets/img/tab2.png" alt="" />
              <div class="content-item-right">
                <div class="item-right-title">自我防护</div>
                <div class="item-right-content">采用国密和来布私有加密算法多重加密</div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="content-item">
              <img class="content-item-left" src="../assets/img/tab6.png" alt="" />
              <div class="content-item-right">
                <div class="item-right-title">流通管控</div>
                <div class="item-right-content">支持数据全生命周期的收发控制</div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="content-item">
              <img class="content-item-left" src="../assets/img/tab9.png" alt="" />
              <div class="content-item-right">
                <div class="item-right-title">无缝兼容</div>
                <div class="item-right-content">加密后不改变原文件后缀，仍然使用原有软件查看编辑，无需改变使用习惯</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 公司资质 -->
    <div class="home_03">
      <div class="title">公司资质</div>
      <div class="content">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="6">
            <img class="zhengshu_img" src="../assets/img/zhengshu1.png" alt="" />
          </el-col>
          <el-col :xs="12" :sm="6">
            <img class="zhengshu_img" src="../assets/img/zhengshu2.png" alt="" />
          </el-col>
          <el-col :xs="12" :sm="6">
            <img class="zhengshu_img" src="../assets/img/zhengshu3.png" alt="" />
          </el-col>
          <el-col :xs="12" :sm="6">
            <img class="zhengshu_img" src="../assets/img/zhengshu4.png" alt="" />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="8" :sm="6" :offset="3" class="web">
            <img class="zhengshu_img" src="../assets/img/zhengshu5.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="6" class="phone">
            <img class="zhengshu_img" src="../assets/img/zhengshu5.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="6">
            <img class="zhengshu_img" src="../assets/img/zhengshu6.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="6">
            <img class="zhengshu_img" src="../assets/img/zhengshu7.png" alt="" />
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 服务客户 -->
    <div class="home_04">
      <div class="title">服务客户</div>
      <div class="content">
        <el-row :gutter="24">
          <el-col :xs="8" :sm="8">
            <img class="huoban_img" src="../assets/img/huoban7.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="8">
            <img class="huoban_img" src="../assets/img/huoban8.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="8">
            <img class="huoban_img" src="../assets/img/huoban9.png" alt="" />
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="home_05">
      <div class="title">合作伙伴</div>
      <div class="content">
        <el-row :gutter="24">
          <el-col :xs="8" :sm="8">
            <img class="huoban_img" src="../assets/img/huoban1.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="8">
            <img class="huoban_img" src="../assets/img/huoban2.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="8">
            <img class="huoban_img" src="../assets/img/huoban3.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="8">
            <img class="huoban_img" src="../assets/img/huoban4.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="8">
            <img class="huoban_img" src="../assets/img/huoban5.png" alt="" />
          </el-col>
          <el-col :xs="8" :sm="8">
            <img class="huoban_img" src="../assets/img/huoban6.png" alt="" />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  components: { swiper,swiperSlide },
  name: "HelloWorld",
  data () {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
        autoplay: {
          delay: 5000, // 自动切换的时间间隔，单位是毫秒
          disableOnInteraction: false, // 用户交互后是否停止自动播放
        },
        on: {
          slideChange: this.onSlideChange,
        },
      },
    };
  },
  created () { },
  computed: {
  },
  mounted () { },
  methods: {
    toDetails () {
      this.$router.replace('/product');
    }
  }
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.home-content {
  overflow: hidden;
}
.home_swiper {
  height: 540px;
  position: relative;
  overflow: hidden;

  .swiper_slide {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .swiper_slide {
    >img {
      width: 100%;
      height: 100%;
    }
  }
  .to-details {
    display: flex;
    align-items: center;
    .el-icon-right {
      margin-left: 5px;
    }
    .el-button {
      margin-top: 24px;
    }
    >p {
      font-size: 18px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      margin-top: 24px;
      margin-left: 16px;
    }
  }
  .el-button--primary {
    background-color: #2F51FF;
    border-color: #2F51FF;
  }
  .el-button--primary:hover {
    background-color: rgb(90, 117, 247);
    border-color: rgb(90, 117, 247);;
  }

  .swiper-pagination {
    width: 100%;
    bottom: 20px;
    font-size: 0;
  }

  .theme_title {
    max-width: 754px;
    position: absolute;
    top: 160px;
    left: 50%;
    margin-left: -600px;

    > h3 {
      font-size: 36px;
      font-weight: 600;
      color: #262626;
      line-height: 36px;
    }

    > p {
      max-width: 648px;
      font-size: 18px;
      font-weight: 400;
      color: #666666;
      line-height: 36px;
      margin-top: 24px;
    }
  }
  .theme_title.one {
    top: 180px;
    max-width: 754px;
    position: absolute;
    top: 160px;
    left: 50%;
    margin-left: -600px;
    >h3 {
      line-height: 54px;
    }
    >p {
      font-size: 22px;
    }
    .phone {
      display: none;
    }
  }
}

.home_02 {
  padding: 56px 0;
  text-align: center;
  min-height: 712px;
  .title {
    font-weight: 600;
    font-size: 36px;
    color: #262626;
    line-height: 36px;
  }
  >p {
    max-width: 656px;
    font-size: 16px;
    color: #666666;
    line-height: 24px;
    margin: 20px auto;
  }
  .content {
    width: 1200px;
    position: relative;
    left: 50%;
    margin-left: -600px;
    .content-item {
      min-height: 128px;
    }
  }

  .content-item {
    width: 100%;
    height: 128px;
    border-radius: 8px;
    border: 1px solid #ECEFF4;
    display: flex;
    padding: 24px;
    margin-top: 24px;
    float: left;
    .content-item-left {
      width: 32px;
      height: 32px;
      margin: auto 24px auto 0;
    }
    .content-item-right {
      text-align: left;

    }
    .item-right-title {
      font-size: 16px;
      color: #262626;
      line-height: 24px;
    }
    .item-right-content {
      font-size: 16px;
      color: #666666;
      line-height: 24px;
      margin-top: 8px;
    }
  }
}

.home_03 {
  padding: 56px 0;
  text-align: center;
  height: 830px;
  background: #FAFCFF;
  .title {
    font-weight: 600;
    font-size: 36px;
    color: #262626;
    line-height: 36px;
    margin-bottom: 20px;
  }
  .content {
    width: 1200px;
    position: relative;
    left: 50%;
    margin-left: -600px;
    .zhengshu_img {
      width: 100%;
    }
    .web {
      display: block;
    }
    .phone {
      display: none;
    }
  }
}

.home_04 {
  padding: 56px 0;
  text-align: center;
  min-height: 372px;

  .title {
    font-weight: 600;
    font-size: 36px;
    color: #262626;
    line-height: 36px;
    margin-bottom: 16px;
  }

  .content {
    width: 1200px;
    position: relative;
    left: 50%;
    margin-left: -600px;
  }

  .huoban_img {
    width: 100%;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #ECEFF4;
    background: #FFFFFF;
    margin-top: 30px;
  }
}
.home_05 {
  padding: 56px 0;
  text-align: center;
  min-height: 520px;
  background: #FAFCFF;
  .title {
    font-weight: 600;
    font-size: 36px;
    color: #262626;
    line-height: 36px;
    margin-bottom: 16px;
  }
  .content {
    width: 1200px;
    position: relative;
    left: 50%;
    margin-left: -600px;
  }
  .huoban_img {
    width: 100%;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #ECEFF4;
    background: #FFFFFF;
    margin-top: 30px;
  }
}

/* 当屏幕宽度小于768像素时 */
@media (max-width: 768px) {
  .home_swiper {
    height: 240px;
    .swiper_slide.one {
      background-image: url('../assets/img/download_bg.png');
      >img {
        display: none;
      }
    }
    .swiper_slide.two {
      display: flex;
      justify-content: center;
    }
    .theme_title.one {
      max-width: 100%;
      position: relative;
      top: 55px;
      left: 0;
      margin-left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      
      >h3 {
        font-size: 19px;
        line-height: 32px;
      }
      >p {
        width: 90%;
        font-size: 18px;
        margin-top: 15px;
        height: auto;
        line-height: 28px;
      }
      .web {
        display: none;
      }
      .phone {
        width: 90%;
        display: block;
      }
    }
    .theme_title.two {
      max-width: 90%;
      position: relative;
      top: 0px;
      left: 0;
      margin-left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      z-index: 1;
      >h3 {
        font-size: 16px;
        line-height:24px;
      }
      p {
        font-size: 16px;
        color: #666666;
        line-height: 24px;
        margin-top: 10px;
      }
    }
    .to-details {
      .el-button {
        margin-top: 10px;
      }
    }
  }
  .home_02 {
    min-height: 1105px;
    .title {
      font-size: 22px;
    }
    .content {
      width: 90%;
      margin-left: -45%;
      .content-item {
        height: 140px;
      }
    }
    >p {
      width: 90%;
    }
  }
  .home_03 {
    height: fit-content;
    .title {
      font-size: 22px;
    }
    .content {
      width: 92%;
      margin-left: -46%;
      .web {
        display: none;
      }
      .phone {
        display: block;
      }
    }
  }
  .home_04 {
    min-height: auto;
    .title {
      font-size: 22px;
    }
    .content {
      width: 92%;
      margin-left: -46%;
      .huoban_img {
        margin-top: 10px;
      }
    }
  }
  .home_05 {
    min-height: auto;
    .title {
      font-size: 22px;
    }
    .content {
      width: 92%;
      margin-left: -46%;
      .huoban_img {
        margin-top: 10px;
      }
    }
  }
}

</style>